<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<h1 class="toc" id="toc"><span epub:type="pagebreak" id="pagevii" title="vii">Contents</span></h1>
<p class="toc"><a href="#/OEBPS/fm1">The Master and Margarita</a></p>
<p class="toc1"><a href="#/OEBPS/p01">Part 1</a></p>
<p class="toc3"><a href="#/OEBPS/p01c01">Chapter 1</a></p>
<p class="toc3"><a href="#/OEBPS/p01c02">Chapter 2</a></p>
<p class="toc3"><a href="#/OEBPS/p01c03">Chapter 3</a></p>
<p class="toc3"><a href="#/OEBPS/p01c04">Chapter 4</a></p>
<p class="toc3"><a href="#/OEBPS/p01c05">Chapter 5</a></p>
<p class="toc3"><a href="#/OEBPS/p01c06">Chapter 6</a></p>
<p class="toc3"><a href="#/OEBPS/p01c07">Chapter 7</a></p>
<p class="toc3"><a href="#/OEBPS/p01c08">Chapter 8</a></p>
<p class="toc3"><a href="#/OEBPS/p01c09">Chapter 9</a></p>
<p class="toc3"><a href="#/OEBPS/p01c10">Chapter 10</a></p>
<p class="toc3"><a href="#/OEBPS/p01c11">Chapter 11</a></p>
<p class="toc3"><a href="#/OEBPS/p01c12">Chapter 12</a></p>
<p class="toc3"><a href="#/OEBPS/p01c13">Chapter 13</a></p>
<p class="toc3"><a href="#/OEBPS/p01c14">Chapter 14</a></p>
<p class="toc3"><a href="#/OEBPS/p01c15">Chapter 15</a></p>
<p class="toc3"><a href="#/OEBPS/p01c16">Chapter 16</a></p>
<p class="toc3"><a href="#/OEBPS/p01c17">Chapter 17</a></p>
<p class="toc3"><a href="#/OEBPS/p01c18">Chapter 18</a></p>
<p class="toc"><span href="#/OEBPS/p02" title="Link target outside of Sample">Part 2</span></p>
<p class="toc3"><a href="#/OEBPS/p02c19">Chapter 19</a></p>
<p class="toc3"><a href="#/OEBPS/p02c20">Chapter 20</a></p>
<p class="toc3"><a href="#/OEBPS/p02c21">Chapter 21</a></p>
<p class="toc3"><a href="#/OEBPS/p02c22">Chapter 22</a></p>
<p class="toc3"><a href="#/OEBPS/p02c23">Chapter 23</a></p>
<p class="toc3"><a href="#/OEBPS/p02c24">Chapter 24</a></p>
<p class="toc3"><a href="#/OEBPS/p02c25">Chapter 25</a></p>
<p class="toc3"><a href="#/OEBPS/p02c26">Chapter 26</a></p>
<p class="toc3"><a href="#/OEBPS/p02c27">Chapter 27</a></p>
<p class="toc3"><a href="#/OEBPS/p02c28">Chapter 28</a></p>
<p class="toc3"><a href="#/OEBPS/p02c29">Chapter 29</a></p>
<p class="toc3"><a href="#/OEBPS/p02c30">Chapter 30</a></p>
<p class="toc3"><a href="#/OEBPS/p02c31">Chapter 31</a></p>
<p class="toc3"><a href="#/OEBPS/p02c32">Chapter 32</a></p>
<p class="toc3"><span href="#/OEBPS/epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span href="#/OEBPS/note" title="Link target outside of Sample"><em>Note on the Text</em></span></p>
<p class="toc"><span href="#/OEBPS/note#note1a" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span class="hlink" href="#/OEBPS/other" title="Link target outside of Sample">Other Books by Mikhail Bulgakov</span></p>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?dd309c32